import { SOURCE, SOURCE_TYPE, getSourceLabel } from '@/services/sourceTranslation'

/**
 * @param {*} data - ChargingPoint
 * @param {*} config - MapsConfig
 */
export const importSource = (data, config) => {
  let source = data.dataSource?.value
  const sourceType = data.meta?.sourceType
  const sourceImportValue = [data.address?.source, data.dataSource?.value].find(source => source?.startsWith('import'))

  source = sourceImportValue || source
  if (sourceType === SOURCE_TYPE.DASHBOARD) {
    const importSettings = config?.imports?.find(i => i.addressSource === source)
    return importSettings?.addressSourceLabel
  }

  return getSourceLabel(source)
}

export const introducedBy = (chargingpoint, config) => {
  const { user, user_name } = chargingpoint.properties

  if (user?.type === 'participation') {
    return 'Inwoner'
  }

  if (user?.name) {
    return user.name
  }

  return importSource(chargingpoint, config) || user_name || getSourceLabel(SOURCE.EVTOOLS)
}
